// src/AirhelpPlus.tsx
import { createIcon } from "@chakra-ui/icon";
import { Fragment, jsx, jsxs } from "react/jsx-runtime";
var AirhelpPlus_default = createIcon({
  displayName: "AirhelpPlus",
  viewBox: "0 0 110 25",
  defaultProps: {
    color: "primary.900"
  },
  path: /* @__PURE__ */ jsxs(Fragment, {
    children: [
      /* @__PURE__ */ jsx("path", {
        d: "M13.6824 16.0754H5.20852L3.86013 19.991H0L6.96673 0.386169H12.0034L18.9701 19.991H14.9911L13.6824 16.0754ZM12.5851 12.8656L11.8183 10.6014C10.9723 8.11084 10.0866 5.6603 9.4388 3.36948C8.77781 5.6603 7.90532 8.17743 7.05926 10.6548L6.31897 12.8656H12.5851Z",
        fill: "currentColor"
      }),
      /* @__PURE__ */ jsx("path", {
        d: "M20.4773 2.10436C20.4773 0.945685 21.4027 0 22.5924 0C23.7821 0 24.7075 0.932286 24.7075 2.10436C24.7075 3.26303 23.7689 4.20865 22.5924 4.20865C21.4159 4.20865 20.4773 3.26303 20.4773 2.10436ZM24.377 19.9911H20.8078V5.87343H24.377V19.9911Z",
        fill: "currentColor"
      }),
      /* @__PURE__ */ jsx("path", {
        d: "M35.997 6.12648L35.3625 9.24299C34.6222 9.0432 34.0405 8.96333 33.5778 8.96333C31.6875 8.96333 30.5109 10.4815 30.5109 13.0255V19.991H26.9417V5.87336H30.2597V7.95112C30.9207 6.59252 32.0444 5.7135 33.763 5.7135C34.5429 5.7135 35.1378 5.88676 35.997 6.12648Z",
        fill: "currentColor"
      }),
      /* @__PURE__ */ jsx("path", {
        d: "M54.0285 19.991H50.1948V11.3206H41.4963V19.991H37.6626V0.386169H41.4963V8.0709H50.1948V0.386169H54.0285V19.991Z",
        fill: "currentColor"
      }),
      /* @__PURE__ */ jsx("path", {
        d: "M67.5918 15.4628L69.588 17.6736C67.539 19.7779 65.6088 20.4306 63.3352 20.4306C58.814 20.4306 55.9851 17.5005 55.9851 12.9988C55.9851 8.6304 58.6157 5.40736 63.031 5.40736C67.301 5.40736 69.588 8.11089 69.588 12.4528C69.588 12.8923 69.5615 13.5583 69.5351 13.8646H59.475C59.7791 15.9023 60.982 17.3939 63.4276 17.3939C65.0802 17.3939 65.9525 16.8479 67.5918 15.4628ZM59.5675 11.2941H66.1245C65.9923 9.41616 64.895 8.23082 62.9385 8.23082C61.0481 8.23082 59.9509 9.46949 59.5675 11.2941Z",
        fill: "currentColor"
      }),
      /* @__PURE__ */ jsx("path", {
        d: "M75.4311 19.991H71.875V0.386169H75.4311V19.991Z",
        fill: "currentColor"
      }),
      /* @__PURE__ */ jsx("path", {
        d: "M92.0054 12.9601C92.0054 17.5417 89.3483 20.4185 85.779 20.4185C83.8885 20.4185 82.5137 19.7525 81.5884 18.5672V25H78.019V5.91465H81.3372V7.76582C82.2758 6.35416 83.7167 5.5018 85.8054 5.5018C89.3615 5.5018 92.0054 8.39185 92.0054 12.9601ZM88.3832 12.9601C88.3832 10.3098 87.0877 8.59164 84.9858 8.59164C82.9235 8.59164 81.4429 10.2432 81.4429 12.9601C81.4429 15.7171 82.9764 17.3019 84.9462 17.3019C86.9819 17.2886 88.3832 15.6371 88.3832 12.9601Z",
        fill: "currentColor"
      }),
      /* @__PURE__ */ jsx("path", {
        d: "M100.403 9.68716V4.74232C100.403 4.09974 100.924 3.57883 101.567 3.57883H102.73C103.373 3.57883 103.894 4.09974 103.894 4.74232V9.68716L102.149 11.4324L100.403 9.68716Z",
        fill: "#FF6B73"
      }),
      /* @__PURE__ */ jsx("path", {
        d: "M103.894 13.1776V18.1225C103.894 18.7651 103.373 19.286 102.73 19.286L101.567 19.286C100.924 19.286 100.403 18.7651 100.403 18.1225L100.403 13.1776L102.149 11.4324L103.894 13.1776Z",
        fill: "currentColor"
      }),
      /* @__PURE__ */ jsx("path", {
        d: "M103.894 9.68716L108.839 9.68716C109.481 9.68716 110.002 10.2081 110.002 10.8507V12.0142C110.002 12.6567 109.481 13.1776 108.839 13.1776H103.894L102.149 11.4324L103.894 9.68716Z",
        fill: "#0D73FF"
      }),
      /* @__PURE__ */ jsx("path", {
        d: "M100.403 13.1776H95.4585C94.816 13.1776 94.295 12.6567 94.295 12.0142L94.295 10.8507C94.295 10.2081 94.816 9.68717 95.4585 9.68717L100.403 9.68716L102.149 11.4324L100.403 13.1776Z",
        fill: "currentColor"
      })
    ]
  })
});

export {
  AirhelpPlus_default
};
